/**
 * Marks dashboard/template source authored against the canonical UTC ISO
 * history-timestamp contract. Unmarked persisted code predates that contract
 * and is rendered through the sandbox's epoch-millisecond compatibility hook.
 */
export const DASHBOARD_UTC_ISO_TIMESTAMP_MARKER = '// @axilon-dashboard-timestamps utc-iso'

export function markDashboardCodeForUtcIsoTimestamps(code: string): string {
  return code.includes(DASHBOARD_UTC_ISO_TIMESTAMP_MARKER)
    ? code
    : `${DASHBOARD_UTC_ISO_TIMESTAMP_MARKER}\n${code}`
}

export function usesUtcIsoDashboardTimestamps(code: string): boolean {
  return code.includes(DASHBOARD_UTC_ISO_TIMESTAMP_MARKER)
}
